import z from 'zod';

export const subscriptionActivityReportFormatSchema = z.enum(['csv', 'xlsx']);

export const subscriptionActivityParametersSchema = z
	.object({
		facilityId: z.string(),
		showOutstandingBalances: z.boolean(),
		format: subscriptionActivityReportFormatSchema.default('csv'),
		accountId: z.number().optional(),
		subscriptionName: z.string().optional(),
		startMonth: z.number().int().min(0).max(11).optional().nullable(),
		endMonth: z.number().int().min(0).max(11).optional().nullable(),
		startYear: z.number().int().min(2021).max(2030).optional().nullable(),
		endYear: z.number().int().min(2021).max(2030).optional().nullable(),
	})
	.superRefine((value, ctx) => {
		if (value.startMonth != null && value.startYear == null) {
			ctx.addIssue({
				code: 'custom',
				path: ['startYear'],
				message: 'startYear is required when startMonth is provided',
			});
		}

		if (value.startYear != null && value.startMonth == null) {
			ctx.addIssue({
				code: 'custom',
				path: ['startMonth'],
				message: 'startMonth is required when startYear is provided',
			});
		}

		if (value.endMonth != null && value.endYear == null) {
			ctx.addIssue({
				code: 'custom',
				path: ['endYear'],
				message: 'endYear is required when endMonth is provided',
			});
		}

		if (value.endYear != null && value.endMonth == null) {
			ctx.addIssue({
				code: 'custom',
				path: ['endMonth'],
				message: 'endMonth is required when endYear is provided',
			});
		}

		const isEndMonthBeforeStartMonth =
			value.startMonth != null && value.endMonth != null && Number(value.startMonth) > Number(value.endMonth);
		const isEndYearBeforeStartYear =
			value.startYear != null && value.endYear != null && Number(value.startYear) > Number(value.endYear);

		if (isEndYearBeforeStartYear || (value.startYear === value.endYear && isEndMonthBeforeStartMonth)) {
			ctx.addIssue({
				code: 'custom',
				path: ['endMonth', 'endYear'],
				message: 'End date must be after start date',
			});
		}
	});

export type SubscriptionActivityParameters = z.infer<typeof subscriptionActivityParametersSchema>;
export type SubscriptionActivityReportFormat = z.infer<typeof subscriptionActivityReportFormatSchema>;
